module.exports = __webpack_public_path__ + "img/jednorazove_vstupenky-min.f68b8710.png";